import {AppFunction} from "../misc/types";
import View from "../framework/view";
import LibraryView from "../views/library";

export class LibraryFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new LibraryView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/library`;
    }

}
